import React from 'react';
import { TrainerHeader } from '../TrainerHeader';
import { TrainerStats } from './TrainerStats';
import { ClientList } from '../clients/ClientList';
import { UpcomingWorkouts } from './UpcomingWorkouts';
import { ClientMetrics } from './ClientMetrics';

export function TrainerDashboardLayout() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <TrainerHeader />
      <main className="container mx-auto px-4 py-6 pt-20 pb-24 space-y-6">
        {/* Quick Stats */}
        <TrainerStats />

        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Client List */}
          <div className="lg:col-span-2">
            <ClientList />
          </div>

          {/* Upcoming Workouts */}
          <div>
            <UpcomingWorkouts />
          </div>
        </div>

        {/* Client Metrics */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <ClientMetrics />
        </div>
      </main>
    </div>
  );
}